import React, { CSSProperties } from 'react'
import styled, { StyledProps } from 'styled-components'

export const SectionTable = styled.table`
  width: 100%;
`
export const SectionTableHead = styled.thead``
export const SectionTableBody = styled.tbody``
export const SectionTableHeadRow: React.FC = ({ children, ...props }) => <tr {...props}>{children}</tr>
export const SectionTableHeadCell = styled.td<
  StyledProps<{ textAlign?: CSSProperties['textAlign']; textTransform?: CSSProperties['textTransform'] }>
>`
  text-transform: ${props => props.textTransform};
  text-align: ${props => props.textAlign};
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  padding: 0 8px 8px;
  color: ${props => props.theme.color.secondary200};
  &:first-child {
    padding-left: 0;
  }
  &:last-child {
    padding-right: 0;
  }
`

export const SectionTableBodyRow: React.FC = ({ children, ...rest }) => <tr {...rest}>{children}</tr>

export const SectionTableBodyCell = styled.td<
  StyledProps<{ textAlign?: CSSProperties['textAlign']; verticalAlign?: CSSProperties['verticalAlign'] }>
>`
  text-align: ${props => props.textAlign || 'left'};
  vertical-align: ${props => props.verticalAlign || 'top'};
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  padding: 8px;
  &:first-child {
    padding-left: 0;
  }
  &:last-child {
    padding-right: 0;
  }
`
